function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getCompanyList, getProductList } from '@/api/baseDate';
import { clause_queryPage, getExcelPath, download, clause_import, saveClause, deleteClause, getAllProductConfData } from '@/api/baseDataManage';
import { delUser } from '@/api/permissions';
export default {
  name: "Clauseliability",
  data: function data() {
    var _this = this;

    var clauseTypeRule = function clauseTypeRule(rule, value, callback) {
      if (_this.markForm_new.clauseType == '') {
        callback(new Error('请选择条款类型'));
      } else {
        callback();
      }
    };

    var clauseTypeRule1 = function clauseTypeRule1(rule, value, callback) {
      if (_this.markForm.clauseType == '') {
        callback(new Error('请选择条款类型'));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      showFlag: false,
      insertFlag: false,
      flagOptions: [{
        value: '1',
        label: '进口'
      }, {
        value: '2',
        label: '出口'
      }, {
        value: '3',
        label: '内陆'
      }],
      fileList: [],
      company: '',
      //保险公司
      companyList: [],
      //获取保险公司列表并匹配
      productConfList: [],
      // 产品配置集合
      // 查询条件
      form: {
        insuranceCompanyCode: '',
        pageNo: 1,
        pageSize: 10,
        clauseName: '',
        //条款名称
        riskName: '',
        //产品名称
        riskCode: '',
        clauseCode: '',
        dutyCode: '',
        dutyName: '',
        ieFlag: ''
      },
      total: 0,
      //数据条数
      // 列表数据
      tableData: [],
      clauseList: [],
      screenLoading: null,
      newumarBtn: false,
      new_edit: false,
      editData: {},
      markForm: {
        tbcClauseId: '',
        type: '',
        riskCode: '',
        riskName: '',
        clauseCode: '',
        clauseName: '',
        clauseEnContent: '',
        clauseType: '',
        dutyCode: '',
        dutyName: '',
        ieFlag: ''
      },
      markForm_new: {
        tbcClauseId: '',
        type: '',
        riskCode: '',
        riskName: '',
        clauseCode: '',
        clauseName: '',
        clauseEnContent: '',
        clauseType: '',
        dutyCode: '',
        dutyName: '',
        ieFlag: ''
      },
      clauseType_option: [// {
      //   value: "",
      //   label: "请选择"
      // },
      {
        value: "1",
        label: "主险"
      }, {
        value: "2",
        label: "附加险"
      }],
      // 新增时的校验
      termsofrule: {
        riskCode: [{
          required: true,
          message: '请输入产品代码',
          trigger: 'blur'
        }],
        riskName: [{
          required: true,
          message: '请输入产品名称',
          trigger: 'blur'
        }],
        clauseCode: [{
          required: true,
          message: '请输入条款代码',
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9_]+$/,
          message: '条款代码必须录入字母或数字'
        }],
        clauseName: [{
          required: true,
          message: '请输入条款名称',
          trigger: 'blur'
        }],
        clauseEnContent: [{
          required: true,
          message: '请输入条款英文名称',
          trigger: 'blur'
        }],
        // clauseType: [{ required: true, message: '请选择条款类型', trigger: 'blur' }],
        clauseType: [{
          required: true,
          validator: clauseTypeRule,
          trigger: 'change'
        }],
        dutyCode: [{
          required: true,
          message: '请输入责任代码',
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9_-]+$/,
          message: '责任代码必须录入字母或数字'
        }],
        dutyName: [{
          required: true,
          message: '请输入责任名称',
          trigger: 'blur'
        }],
        ieFlag: [{
          required: true,
          message: '请选择进出口标识',
          trigger: 'change'
        }]
      },
      // 编辑时的校验
      termsofrule1: {
        riskCode: [{
          required: true,
          message: '请输入产品代码',
          trigger: 'blur'
        }],
        riskName: [{
          required: true,
          message: '请输入产品名称',
          trigger: 'blur'
        }],
        clauseCode: [{
          required: true,
          message: '请输入条款代码',
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9_]+$/,
          message: '条款代码必须录入字母或数字'
        }],
        clauseName: [{
          required: true,
          message: '请输入条款名称',
          trigger: 'blur'
        }],
        clauseEnContent: [{
          required: true,
          message: '请输入条款英文名称',
          trigger: 'blur'
        }],
        // clauseType: [{ required: true, message: '请选择条款类型', trigger: 'blur' }],
        clauseType: [{
          required: true,
          validator: clauseTypeRule1,
          trigger: 'change'
        }],
        dutyCode: [{
          required: true,
          message: '请输入责任代码',
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9_-]+$/,
          message: '责任代码必须录入字母或数字'
        }],
        dutyName: [{
          required: true,
          message: '请输入责任名称',
          trigger: 'blur'
        }],
        ieFlag: [{
          required: true,
          message: '请选择进出口标识',
          trigger: 'change'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    getCompanyList().then(function (res) {
      _this2.companyList = Object.assign([], res); // this.company = this.form.insuranceCompanyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode

      _this2.company = _this2.form.insuranceCompanyCode = JSON.parse(sessionStorage.getItem('newinsurancecompanyCode'));

      _this2.getData();
    });
    getProductList({
      insuranceCompanyCode: this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode || ''
    }).then(function (res) {
      console.log(res);
      _this2.clauseList = res;
    });
    getAllProductConfData().then(function (res) {
      console.log("产品配置信息:" + res);
      _this2.productConfList = res;
    });
  },
  methods: {
    //   查询
    submitForm: function submitForm(formName) {
      this.form.pageNo = 1;
      this.getData();
    },
    // 获取数据
    getData: function getData() {
      var _this3 = this;

      this.loading = true;
      clause_queryPage(_objectSpread({}, this.form)).then(function (res) {
        _this3.loading = false;
        _this3.total = res.totalCount;
        _this3.tableData = Object.assign([], res.content);
      });
    },
    //   重置查询条件
    resetForm: function resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.form.clauseName = this.form.riskName = this.form.riskCode = this.form.clauseCode = this.form.dutyCode = this.form.dutyName = this.form.ieFlag = '';
      this.getData();
    },
    // 分页方法
    handleSizeChange: function handleSizeChange(val) {
      this.form.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.pageNo = val;
      this.getData();
    },
    //编辑/新增保存
    editSave: function editSave(formName, type) {
      var _this4 = this;

      var data = type == 'edit' ? this.markForm : this.markForm_new;

      if (type == 'edit') {
        this.markForm.type = '1';
      } else {
        this.markForm_new.type = '0';
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.new_edit = _this4.newumarBtn = false;

          _this4.openFullScreen();

          saveClause(data).then(function (res) {
            console.log(res);

            if (res.resultCode == '0000') {
              _this4.$message({
                message: '保存成功',
                type: 'success'
              });

              for (var key in _this4.markForm_new) {
                _this4.markForm_new[key] = '';
              }

              _this4.getData();
            } else {
              _this4.$message({
                message: res.resultMsg,
                type: 'warning'
              });
            }

            _this4.screenLoading.close();

            _this4.markForm_new = {
              tbcClauseId: '',
              type: '',
              riskCode: '',
              riskName: '',
              clauseCode: '',
              clauseName: '',
              clauseEnContent: '',
              clauseType: '',
              dutyCode: '',
              dutyName: '',
              ieFlag: ''
            };
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 编辑
    edit: function edit(data) {
      this.editData = data;
      this.new_edit = true;
      this.showFlag = true;

      for (var key in this.markForm) {
        this.markForm[key] = data[key];
      }
    },
    // 删除
    dele: function dele(data) {
      var _this5 = this;

      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteClause({
          tbcClauseId: data.tbcClauseId
        }).then(function (res) {
          console.log(res);

          if (res.resultCode == '0000') {
            _this5.$message({
              type: 'success',
              message: '删除成功!'
            });

            _this5.getData();
          } else {
            _this5.$message({
              type: 'warning',
              message: res.resultMsg
            });
          }
        });
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 取消
    selectcancel: function selectcancel(formname, type) {
      var _this6 = this;

      if (type == 'new') {
        this.newumarBtn = false;
      } else {
        this.new_edit = false;
      }

      this.$nextTick(function () {
        _this6.$refs[formname].clearValidate();
      });
    },
    // 获取下载链接
    getExecl: function getExecl() {
      getExcelPath({
        fileDownloadType: 'clause'
      }).then(function (res) {
        if (res.rtnCode == '0000') {
          // 获取下载文件
          download({
            fileSrc: res.fileSrc
          }).then(function (res2) {
            var blob = new Blob([res2], {
              type: "application/vnd.ms-excel"
            }); // 兼容ie

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, "产品条款责任清单模板.xlsx");
            } else {
              var url = window.URL.createObjectURL(blob);
              var link = document.createElement("a"); // 创建a标签

              link.href = url;
              link.download = "产品条款责任清单模板.xlsx"; // 重命名文件

              link.click();
              window.URL.revokeObjectURL(url); // 释放内存
            }
          });
        }
      });
    },
    openFullScreen2: function openFullScreen2() {
      this.screenLoading = this.$loading({
        lock: true,
        text: '导入中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    openFullScreen: function openFullScreen() {
      this.screenLoading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    // 上传
    importExcel: function importExcel(file) {
      var _this7 = this;

      var extension = file.file.name.substring(file.file.name.lastIndexOf('.') + 1);

      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message.warning('只能上传后缀是.xlsx或者.xls的文件');
        return;
      }

      var dataFile = new FormData();
      dataFile.append('file', file.file);
      this.openFullScreen2();
      clause_import(dataFile).then(function (res) {
        _this7.screenLoading.close();

        if (res.resultCode == '0000') {
          _this7.$message({
            type: 'success',
            message: '导入成功'
          });

          _this7.getData();
        } else {
          _this7.$message({
            type: 'warning',
            message: res.resultMsg
          });
        }
      });
    },
    riskCodeChange: function riskCodeChange() {
      var _this8 = this;

      this.productConfList.forEach(function (ele) {
        if (_this8.markForm_new.riskCode == ele.riskCode) {
          console.log(ele.riskCode, ele.riskName);
          _this8.markForm_new.riskName = ele.riskName;
          _this8.markForm_new.ieFlag = ele.ieFlag;
        }
      });
      this.insertFlag = true;
    }
  }
};